var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      { staticClass: "head-container" },
      [
        _vm.crud.props.searchToggle
          ? _c(
              "div",
              [
                _c("label", { staticClass: "el-form-item-label" }, [
                  _vm._v("统计时间"),
                ]),
                _vm._v(" "),
                _c("date-range-picker", {
                  staticClass: "date-item",
                  model: {
                    value: _vm.statTime,
                    callback: function ($$v) {
                      _vm.statTime = $$v
                    },
                    expression: "statTime",
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "filter-item",
                        attrs: {
                          size: "mini",
                          type: "success",
                          icon: "el-icon-search",
                        },
                        on: { click: _vm.doSearch },
                      },
                      [_vm._v("搜索")]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("crudOperation", { attrs: { permission: _vm.permission } }),
        _vm._v(" "),
        _c(
          "el-drawer",
          {
            attrs: {
              title: _vm.rowData.deptName,
              visible: _vm.drawer,
              direction: _vm.direction,
              size: "70%",
              "before-close": _vm.handleClose,
            },
            on: {
              "update:visible": function ($event) {
                _vm.drawer = $event
              },
            },
          },
          [
            _c(
              "el-table",
              {
                ref: "table",
                staticStyle: { width: "100%" },
                attrs: {
                  border: "",
                  data: _vm.form1,
                  size: "small",
                  "max-height": "800",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { width: "50", label: "序号" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.$index + 1) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "cust_id", label: "客户编号", width: "80px" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "cust_name", label: "姓名", width: "90px" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "mobile", label: "联系电话", width: "100px" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "city", label: "城市", width: "50px" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "address", label: "楼盘" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "create_time", label: "首次提交时间" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "msg_from", label: "推广渠道来源" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "follow_status", label: "跟进状态" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "promoter_name", label: "跟进客服" },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.crud.loading,
                expression: "crud.loading",
              },
            ],
            ref: "table",
            staticStyle: { width: "100%" },
            attrs: { data: _vm.crud.data, size: "small", "max-height": "800" },
          },
          [
            _c("el-table-column", {
              attrs: { width: "50", label: "序号" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " + _vm._s(scope.$index + 1) + "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "dept_name", label: "部门" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "nick_name", label: "用户名" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "total", label: "总数" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-link",
                        {
                          staticStyle: { color: "#00a0e9" },
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.onDrawer(scope, "total"), (_vm.drawer = true)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.total))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "invalid_num", label: "无效数" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-link",
                        {
                          staticStyle: { color: "#00a0e9" },
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.onDrawer(scope, "invalid_num"),
                                (_vm.drawer = true)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.invalid_num))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "follow_calendar_num", label: "计划跟进数" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-link",
                        {
                          staticStyle: { color: "#00a0e9" },
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.onDrawer(scope, "follow_calendar_num"),
                                (_vm.drawer = true)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.follow_calendar_num))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "following_num", label: "跟进中数" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-link",
                        {
                          staticStyle: { color: "#00a0e9" },
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.onDrawer(scope, "following_num"),
                                (_vm.drawer = true)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.following_num))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "measure_num", label: "量尺数" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-link",
                        {
                          staticStyle: { color: "#00a0e9" },
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.onDrawer(scope, "measure_num"),
                                (_vm.drawer = true)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.measure_num))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "assign_store_num", label: "分配门店数" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-link",
                        {
                          staticStyle: { color: "#00a0e9" },
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.onDrawer(scope, "assign_store_num"),
                                (_vm.drawer = true)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.assign_store_num))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "in_store_num", label: "进店数" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-link",
                        {
                          staticStyle: { color: "#00a0e9" },
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.onDrawer(scope, "in_store_num"),
                                (_vm.drawer = true)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.in_store_num))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "in_store_ratio", label: "进店占比" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.in_store_ratio != undefined
                        ? _c("span", [
                            _vm._v(_vm._s(scope.row.in_store_ratio) + "%"),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "sign_num", label: "成交数" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-link",
                        {
                          staticStyle: { color: "#00a0e9" },
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.onDrawer(scope, "sign_num"),
                                (_vm.drawer = true)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.sign_num))]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }